import {
  type EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
  provideAppInitializer,
} from '@angular/core';

import { AuthStore } from './auth.store';

export function provideAuth(): EnvironmentProviders {
  return makeEnvironmentProviders([provideAppInitializer(() => inject(AuthStore).initialize())]);
}
